(() => {
  'use strict';
  if (window.__ratchwellLocalApp) return;
  window.__ratchwellLocalApp = true;

  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  const live=JSON.parse(document.getElementById('rw-live-data').textContent);
  const products=Object.fromEntries(live.variants.map((v,i)=>['pack-'+(i+1),v]));
  let selectedPack='1',galleryIndex=0;
  const layers=[];let priorOverflow='';
  function text(selector,value){$$(selector).forEach(e=>e.textContent=value);}
  const focusable = element => $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', element)
    .filter(node => !node.disabled && !node.closest('[hidden]') && node.getClientRects().length > 0);
  function syncLock() {
    if (layers.length) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add('has-modal');
    } else {
      document.body.style.overflow = priorOverflow;
      document.body.classList.remove('has-modal');
    }
  }
  function openLayer(element) {
    if (!element || layers.some(layer => layer.element === element)) return;
    if (!layers.length) priorOverflow = document.body.style.overflow;
    layers.push({ element, trigger: document.activeElement });
    element.hidden = false;
    element.classList.add('is-open');
    if (element instanceof HTMLDialogElement && !element.open) element.showModal();
    if (element.id === 'cart-drawer') {
      if ($('#cart-overlay')) $('#cart-overlay').hidden = false;
      $$('[data-open-cart]').forEach(button => button.setAttribute('aria-expanded', 'true'));
    }
    if (element.id === 'navigation-dialog') $$('[data-open-menu]').forEach(button => button.setAttribute('aria-expanded', 'true'));
    syncLock();
    (focusable(element)[0] || element).focus({ preventScroll: true });
  }
  function closeLayer(element) {
    const index = layers.findIndex(layer => layer.element === element);
    if (index === -1) return;
    const [{ trigger }] = layers.splice(index, 1);
    element.classList.remove('is-open');
    if (element instanceof HTMLDialogElement && element.open) element.close();
    element.hidden = true;
    if (element.id === 'cart-drawer') {
      if ($('#cart-overlay')) $('#cart-overlay').hidden = true;
      $$('[data-open-cart]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    }
    if (element.id === 'navigation-dialog') $$('[data-open-menu]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    syncLock();
    if (trigger?.isConnected && !trigger.closest('[hidden]')) trigger.focus({ preventScroll: true });
    else if (layers.length) (focusable(layers.at(-1).element)[0] || layers.at(-1).element).focus({ preventScroll: true });
  }
  function updateSelection() {
    const input = $('#buy-form input[name="pack"]:checked');
    selectedPack = input && ['1', '2', '3'].includes(input.value) ? input.value : '1';
    const product = products[`pack-${selectedPack}`]; if(!product)return; const nativeId=$('#buy-form input[name=id]');if(nativeId)nativeId.value=products["pack-1"].id; const nativeQty=$('#buy-form input[name=quantity]');if(nativeQty)nativeQty.value=selectedPack; const cta=$('[data-add-cart]');if(cta)cta.disabled=!product.available;
    text('#selected-price, .selected-price', money(product.price));
    const referencePrice=Number(input?.dataset.referencePrice||0);
    const hasSaving=referencePrice>product.price;
    text('[data-sticky-reference]',hasSaving?money(referencePrice):'');
    text('[data-sticky-saving]',hasSaving?`Save ${Math.round((referencePrice-product.price)/referencePrice*100)}%`:'');
    $$('[data-sticky-reference], [data-sticky-saving]').forEach(node=>{node.hidden=!hasSaving;});
    $$('#buy-form input[name="pack"]').forEach(radio => {
      radio.closest('label')?.classList.toggle('is-active', radio.checked);
      radio.closest('label')?.classList.toggle('is-selected', radio.checked);
    });
  }
  const images = [
    { src: window.RatchwellMedia["assets/gallery-real-scenes-20261017/01-cover.webp"], alt: 'Complete blue offset extension set: one wrench, three adapters and one connector sleeve' },
    { type: 'video' },
    { src: window.RatchwellMedia["assets/gallery-real-scenes-20261017/03-engine-access.webp"], alt: 'Illustrated engine-bay application: blue extension passes the obstruction with the hand ratchet within reach' },
    { src: window.RatchwellMedia["assets/gallery-real-scenes-20261017/04-manual-operation.webp"], alt: 'Illustrated application: close-up of the hand ratchet at the accessible end of the extension' },
    { src: window.RatchwellMedia["assets/gallery-message-20261017/03-kit.webp"], alt: 'Five-piece set: one extension wrench, three drive adapters and one connector sleeve' },
    { src: window.RatchwellMedia["assets/gallery-message-20261017/04-fit.webp"], alt: 'Nominal body dimensions: 390 mm long, 38 mm wide and 18 mm thick; allow space for connected tools' }
  ];
  function hydrateVideo(video) {
    if (!video || video.dataset.sourceReady) return;
    if (video.dataset.poster) video.poster = video.dataset.poster;
    video.querySelectorAll('source[data-video-src]').forEach(source => {
      source.src = source.dataset.videoSrc;
    });
    video.dataset.sourceReady = 'true';
    video.load();
  }
  function play(video) {
    if (!video) return;
    hydrateVideo(video);
    video.controls = true;
    const result = video.play();
    if (result?.catch) result.catch(() => { /* Native controls allow retry if playback is blocked. */ });
  }
  function selectGallery(index, userInitiated = false) {
    if (!Number.isInteger(index)) return;
    galleryIndex = ((index % images.length) + images.length) % images.length;
    const isVideo = images[galleryIndex].type === 'video';
    const galleryMain = $('.gallery-main');
    if (galleryMain) galleryMain.dataset.activeGallery = String(galleryIndex);
    const image = $('#hero-image');
    const video = $('#hero-video');
    if (image) image.hidden = isVideo;
    if (video) {
      video.hidden = !isVideo;
      if (!isVideo) video.pause();
      else {
        hydrateVideo(video);
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.controls = false;
        const playback = video.play();
        if (playback?.catch) playback.catch(() => { /* A muted loop can retry on a later gallery selection. */ });
      }
    }
    if (image && !isVideo) {
      const original = images[galleryIndex].src;
      image.sizes = '(max-width:520px) calc(100vw - 36px), (max-width:800px) min(620px, calc(100vw - 44px)), (max-width:1100px) calc((100vw - 93px) / 2), 650px';
      image.srcset = [480, 672, 800, 1024].map(width => `${original.replace(/(\.[a-z0-9]+)(\?|$)/i, `_${width}x$1$2`)} ${width}w`).concat(`${original} 1254w`).join(', ');
      image.src = original;
      image.alt = images[galleryIndex].alt;
    }
    $$('[data-gallery-index]').forEach(button => {
      const active = Number(button.dataset.galleryIndex) === galleryIndex;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-current', String(active));
      if (active && userInitiated) {
        const rail = button.parentElement;
        rail.scrollTo({ left: button.offsetLeft - (rail.clientWidth - button.offsetWidth) / 2, behavior: 'smooth' });
      }
    });
    $$('[data-zoom]').forEach(button => { button.hidden = isVideo; });
    if ($('.zoom-hint')) $('.zoom-hint').hidden = isVideo;
  }

  // Horizontal swipes on the main media; vertical gestures remain normal page scrolling.
  const gallerySurface = $('.gallery-main');
  let galleryGesture = null;
  let blockGalleryClickUntil = 0;
  gallerySurface?.addEventListener('pointerdown', event => {
    if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
    blockGalleryClickUntil = 0;
    galleryGesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
  });
  gallerySurface?.addEventListener('pointermove', event => {
    if (!galleryGesture || event.pointerId !== galleryGesture.id) return;
    const dx = event.clientX - galleryGesture.x;
    const dy = event.clientY - galleryGesture.y;
    if (Math.abs(dx) > 14 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      gallerySurface.setPointerCapture(event.pointerId);
    }
  });
  gallerySurface?.addEventListener('pointerup', event => {
    if (!galleryGesture || event.pointerId !== galleryGesture.id) return;
    const dx = event.clientX - galleryGesture.x;
    const dy = event.clientY - galleryGesture.y;
    galleryGesture = null;
    if (gallerySurface.hasPointerCapture(event.pointerId)) gallerySurface.releasePointerCapture(event.pointerId);
    if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;
    blockGalleryClickUntil = performance.now() + 500;
    selectGallery(galleryIndex + (dx < 0 ? 1 : -1), true);
  });
  gallerySurface?.addEventListener('pointercancel', () => { galleryGesture = null; });
  gallerySurface?.addEventListener('click', event => {
    if (performance.now() >= blockGalleryClickUntil) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  gallerySurface?.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    selectGallery(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
  });

  $('#buy-form')?.addEventListener('change', event => {
    if (event.target.matches('input[name="pack"]')) updateSelection();
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('button, a, [data-gallery-index]');
    if (!button) return;
    if (button.matches('[data-open-menu]')) { event.preventDefault(); openLayer($('#navigation-dialog')); }
    else if (button.matches('[data-close-menu], [data-menu-link]')) {
      closeLayer($('#navigation-dialog'));
      if(button.matches('[data-menu-link]')&&!$('#buy-form')){
        event.preventDefault();
        window.location.href=(document.body.dataset.root||'/')+'products/offset-extension-wrench#buy-form';
      }
    }
    else if (button.matches('[data-gallery-index]')) selectGallery(Number(button.dataset.galleryIndex), true);
    else if (button.matches('[data-gallery-step]')) selectGallery(galleryIndex + Number(button.dataset.galleryStep), true);
    else if (button.matches('[data-zoom]') && images[galleryIndex].type !== 'video') {
      const image = $('#zoom-image');
      if (image) { image.src = images[galleryIndex].src; image.alt = images[galleryIndex].alt; }
      openLayer($('#zoom-dialog'));
    }
    else if (button.matches('[data-close-zoom]')) closeLayer($('#zoom-dialog'));
    else if (button.matches('[data-open-video]')) {
      const video = $('#demo-video');
      if (video) { video.hidden = false; play(video); video.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
    else if (button.matches('[data-choose-set]')) {
      event.preventDefault();
      const form=$('#buy-form');
      if (!form) return;
      const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({top:Math.max(0,window.scrollY+form.getBoundingClientRect().top-24),behavior:reducedMotion?'instant':'smooth'});
      $('input[name="pack"]:checked',form)?.focus({preventScroll:true});
    }
  });
  document.addEventListener('keydown', event => {
    const current = layers.at(-1)?.element;
    if (!current) return;
    if (event.key === 'Escape') { event.preventDefault(); closeLayer(current); }
    else if (event.key === 'Tab') {
      const nodes = focusable(current);
      if (!nodes.length) { event.preventDefault(); current.focus(); return; }
      const first = nodes[0];
      const last = nodes.at(-1);
      if (event.shiftKey && (document.activeElement === first || !current.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !current.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  }, true);
  $$('dialog').forEach(dialog => {
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeLayer(dialog); });
    dialog.addEventListener('close', () => closeLayer(dialog));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeLayer(dialog);
    });
  });
  $$('video').forEach(video => {
    const syncPlayback = () => {
      const playing = !video.paused && !video.ended;
      video.dataset.playing = String(playing);
      const stage = video.closest('.demo-stage');
      if (stage) {
        stage.classList.toggle('is-playing', playing);
        $$('[data-open-video]', stage).forEach(button => { button.hidden = playing; });
      }
    };
    video.addEventListener('play', () => {
      // The muted lower demonstration runs independently, like an animated image.
      if (video.id !== 'demo-video') $$('video').forEach(other => { if (other !== video && other.id !== 'demo-video') other.pause(); });
      syncPlayback();
    });
    video.addEventListener('pause', syncPlayback);
    video.addEventListener('ended', syncPlayback);
    syncPlayback();
  });
  // Keep the same animation when viewed, without running SMIL below the fold.
  if ('IntersectionObserver' in window) {
    const diagrams = $$('.mechanism-svg, .access-motion-svg').filter(svg =>
      typeof svg.pauseAnimations === 'function' && typeof svg.unpauseAnimations === 'function');
    const motionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.unpauseAnimations();
        else entry.target.pauseAnimations();
      });
    }, { rootMargin: '200px 0px', threshold: 0 });
    diagrams.forEach(svg => { svg.pauseAnimations(); motionObserver.observe(svg); });
  }
  const mechanismLoop = $('#demo-video');
  if (mechanismLoop) {
    mechanismLoop.muted = true;
    mechanismLoop.defaultMuted = true;
    function startMechanismLoop() {
      hydrateVideo(mechanismLoop);
      const playback = mechanismLoop.play();
      if (playback?.catch) playback.catch(() => { /* Retry when visible. */ });
    }
    if ('IntersectionObserver' in window) {
      // Warm the original video shortly before it appears; keep the same
      // continuous muted animation while it is on screen.
      const preloadObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          hydrateVideo(mechanismLoop);
          mechanismLoop.preload = 'auto';
          preloadObserver.disconnect();
        }
      }, { rootMargin: '600px 0px' });
      preloadObserver.observe(mechanismLoop);
      const playbackObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) startMechanismLoop();
        else mechanismLoop.pause();
      });
      playbackObserver.observe(mechanismLoop);
    } else startMechanismLoop();
  }
  const stickyBuy=$('#sticky-buy');
  const primaryBuy=$('#buy-form [data-add-cart]');
  if (stickyBuy && primaryBuy) {
    function updateStickyBuy() {
      const show=primaryBuy.getBoundingClientRect().bottom<=0 && !document.querySelector('dialog[open]');
      stickyBuy.hidden=!show;
      stickyBuy.classList.toggle('is-open',show);
    }
    if ('IntersectionObserver' in window) {
      const observer=new IntersectionObserver(updateStickyBuy,{threshold:0});
      observer.observe(primaryBuy);
    } else {
      let pending=false;
      window.addEventListener('scroll',()=>{
        if(pending)return;
        pending=true;
        requestAnimationFrame(()=>{pending=false;updateStickyBuy();});
      },{passive:true});
    }
    window.addEventListener('resize',updateStickyBuy,{passive:true});
    new MutationObserver(updateStickyBuy).observe(document.body,{attributes:true,subtree:true,attributeFilter:['open']});
    updateStickyBuy();
  }
  updateSelection();
  selectGallery(0);
})();